import { BarChartOutlined, CopyOutlined, TableOutlined, ZoomInOutlined, } from "@ant-design/icons"
import { ArchiveSvg, DeleteSvg, EditSVG, MoreSvg } from "assets/svg/icon"
import GenericButtonsList from "components/generic-buttons-list/generic-buttons-list"

type IconType = keyof typeof ICONS_MAP

interface MoreOptionsButtonProps {
  options: {
    title: string
    icon: IconType
    onClick(): void
  }[]
}

const ICONS_MAP = {
  more: MoreSvg,
  edit: EditSVG,
  delete: DeleteSvg,
  archive: ArchiveSvg,
  copy: CopyOutlined,
  zoom: ZoomInOutlined,
  report: BarChartOutlined,
  timesheet: TableOutlined,
}

export function MoreOptionsButton(props: MoreOptionsButtonProps) {
  const {
    options = []
  } = props

  const genericButtonsListOptions = options.map((option) => ({
    title: option.title,
    Icon: ICONS_MAP[option.icon],
    callback: option.onClick,
  }))

  const buttons = [{
    title: '',
    icon: MoreSvg,
    type: 'text' as const,
    options: genericButtonsListOptions
  }]

  return <GenericButtonsList buttons={buttons} />
}